/*core/util/compat*/
function _(require, module, exports) {
    exports.is_ie = navigator.userAgent.indexOf('MSIE') >= 0 || navigator.userAgent.indexOf('Trident') > 0 || navigator.userAgent.indexOf('Edge') > 0;
    exports.is_little_endian = function () {
        var buf = new ArrayBuffer(4);
        var buf8 = new Uint8Array(buf);
        var buf32 = new Uint32Array(buf);
        buf32[1] = 168496141;
        var little_endian = true;
        if (buf8[4] == 10 && buf8[5] == 11 && buf8[6] == 12 && buf8[7] == 13) {
            little_endian = false;
        }
        return little_endian;
    }();    
}